import { dom, mapActiveClass } from "../helpers/dom.js";


class FullClose {
  constructor({ onClick }) {
    this._onClick = onClick;
  }
  init() {
    const element = this._makeDom();
    element.addEventListener("click", this._onClick);
    return element;
  }
  _makeDom() {
    return dom("button.full__close", {}, [
      dom("i.full__close-icon.icon-close", {}, ""),
      dom("span.full__close-text", {}, "Закрыть")
    ]);
  }
}

export default FullClose;



// WEBPACK FOOTER //
// ./src/js/components/fullClose.js